<template>
  <div class="gallery">
    <header-main class="anchored"></header-main>
    <nav-mobile></nav-mobile>
    <section id="gallery">
      <header class="subpage">
        <h3>Galeria</h3>
      </header>
      <section class="items">
        <img v-for="(item, index) in gallery" :key="index" :src="require('@/assets/gallery/' + item.small)">
      </section>
    </section>
    <footer-main></footer-main>
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import NavMobile from '@/components/NavMobile.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'Gallery',
  components: {
    HeaderMain,
    NavMobile,
    FooterMain,
  },
  data(){
    return{
      gallery: [
        { small: 'img1.webp' },
        { small: 'img2.webp' },
        { small: 'img3.webp' },
        { small: 'img4.webp' },
        { small: 'img5.webp' },
        { small: 'img6.webp' },
        { small: 'img7.webp' },
        { small: 'img8.webp' },
        { small: 'img9.webp' }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
  section#gallery { overflow: hidden; }
  section.items { display: flex; flex-wrap: wrap; justify-content: center; margin: 100px 0; }
  img { display: block; margin: 30px; border-radius: 3px; box-shadow: 0 0 5px #000; }

  @media (max-width: 540px) {
    section.items { margin: 30px 0; }
    img { width: calc(100% - 60px);  }
  }
</style>
